import { render, staticRenderFns } from "./DashboardGestor.vue?vue&type=template&id=412189f0&scoped=true&"
import script from "./DashboardGestor.vue?vue&type=script&lang=js&"
export * from "./DashboardGestor.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGestor.vue?vue&type=style&index=0&id=412189f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412189f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
